import { render } from "./NotDeliveredDeliveries.vue?vue&type=template&id=b4cfa6e2"
import script from "./NotDeliveredDeliveries.vue?vue&type=script&lang=js"
export * from "./NotDeliveredDeliveries.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__